import ServiceAgreementView from "../views/ServiceAgreementView.vue";

export const ServiceAgreementRouters = [
    {
        path: "/serviceAgreement",
        name: "ServiceAgreementView",
        components: {
            default: ServiceAgreementView,
        },
    },
];
